import { usePostRobot } from '@lib/sdk/utils/postrobot'
import {
  UI_API_METHOD_TYPES,
  type UiOpenSharingSettingsRequest,
  type UiOpenSharingSettingsResponse,
} from './types.ui'

export async function openSharingSettings(
  payload: UiOpenSharingSettingsRequest,
): Promise<UiOpenSharingSettingsResponse> {
  const pr = await usePostRobot()
  const response = await pr.send(
    window.parent,
    UI_API_METHOD_TYPES.UI_OPEN_SHARING_SETTINGS,
    payload,
  )
  return response.data as UiOpenSharingSettingsResponse
}
